import { useState } from 'react';
import { NokiaPhone } from './components/NokiaPhone';
import { GameUI } from './components/GameUI';
import { useGameStore } from './stores/gameStore';
import { playClick, playMenuBeep } from './utils/audio';

export default function App() {
  const {
    appScreen,
    currentGame,
    phase,
    startGame,
    goToLevelSelect,
    goToHighScores,
    openGamesMenu,
    openSnakeFromMenu,
    openBounceFromMenu,
    openBrickFromMenu,
    bounce,
    brick,
    bounceStart,
    brickStart,
    bounceBackToMenu,
    brickBackToMenu
  } = useGameStore();

  const [showInstallHint, setShowInstallHint] = useState(false);

  const handleOpenPhone = () => {
    playMenuBeep();
    openGamesMenu();
  };

  const handleInstallHint = () => {
    playClick();
    setShowInstallHint(true);
  };

  return (
    <div className="landing">
      <div className="hero">
        <div className="hero-text">
          <div className="landing-logo-row">
            <img src="/images/logo.png" alt="Nostalogia logo" className="landing-logo" />
            <div className="landing-title">Nostalogia</div>
          </div>
          <h1 className="hero-headline">Play Your First Phone Again.</h1>
          <p className="hero-subtitle">
            Snake, Bounce, Brick & more in a retro Nokia-style phone – right in your
            browser. No download, just tap and play.
          </p>
          <div className="hero-actions">
            <button type="button" className="hero-btn primary" onClick={handleOpenPhone}>
              Open Nostalogia Phone
            </button>
            <button
              type="button"
              className="hero-btn secondary"
              onClick={handleInstallHint}
            >
              Add to Home Screen
            </button>
          </div>
          {showInstallHint && (
            <div className="install-hint">
              <strong>Tip:</strong> On mobile, open this page in your browser menu and
              choose “Add to Home Screen” to install Nostalogia as an app.
            </div>
          )}
        </div>

        <div className="hero-phone">
          <div className="hero-phone-label">GAMES</div>
          <NokiaPhone />
          <div className="hero-phone-tags">
            <span>Snake ▸</span>
            <span>Bounce ▾</span>
            <span>Brick ▪︎</span>
          </div>
        </div>
      </div>

      <div className="app">
        <GameUI />
      </div>

      <footer className="landing-footer">
        <span>Retro mobile arcade • No download • PWA ready</span>
      </footer>
    </div>
  );
}
